import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async createPrescription ({ state }, data) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/prescriptions', data.prescription)).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },

    async sharePrescription ({ state }, data) {
      return (await Vue.http.post(this.state.baseUrl + '/prescriptions/_share', data)).data
    },

    async updatePrescription ({ state }, data) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/prescriptions/' + data.prescription._id, data.prescription)).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async getPrescriptions ({ state }, appointmentId) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/prescriptions/byAppointment/' + appointmentId)).data
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async getLabPrescriptions ({ state }, options) {
      let data = (await Vue.http.post(this.state.baseUrl + '/prescriptions/_filter?pageSize=2&pageNumber=' + options.pageNumber, { patientId: options.patientId, hasLabTests: options.hasLabTests })).data
      return data
    },
    async getPrescription ({ state }, options) {
      let data = (await Vue.http.post(this.state.baseUrl + '/prescriptions/_filter', { appointmentId: options.apptid, patientId: options.patientId })).data
      return data
    },
    async getPrescriptionByPatientId ({ state }, options) {
      let data = (await Vue.http.get(this.state.baseUrl + '/prescriptions/byPatient/' + options.patientId)).data
      return data
    },
    async getHistoricPrescription ({ state }, options) {
      let data = (await Vue.http.get(this.state.baseUrl + '/prescriptions/' + options.prescriptionId)).data
      return data
    },
    async searchDrugs ({ state }, searchFor) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/drugs/search/' + (this.state.appointment.endpoint ? this.state.appointment.endpoint : 'null') + '?query=' + searchFor)).data
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async emailPrescription ({ state }, data) {
      return (await Vue.http.post(this.state.baseUrl + '/prescriptions/notification', data)).data
    },
    async getFrequentDrugs ({ state }, providerId) {
      return (await Vue.http.get(this.state.baseUrl + "/frequentdrugs/" + providerId)).data
    },
    async removeFrequentDrug ({ state }, options) {
      return (await Vue.http.delete(this.state.baseUrl + "/frequentdrugs", {
        data: {
          providerId: options.providerId,
          drugId: options.drugId,
        },
      })).data
    },
    async addFrequentDrug ({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + "/frequentdrugs", {
        providerId: options.providerId,
        drugId: options.drugId,
      })).data
    },
  }
}
